import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import formatters from '@/utils/formatters';
import dateUtils from '@/utils/date';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import {mapGetters} from 'vuex';
import {ProtocolosService} from '@/services/ProtocolosService';

const constProcessoFaseTerrasIndigenas = 'Processo da fase - Terras indígenas';
const constTerrasIndigenas = 'Terras indígenas';

export default {
    data() {
        return {
            camadas: [],
            carsConsultados: 0,
            cpfsCnpjsConsultados: 0,
            camadaCar: {},
            camadaPastagem: {},
            dadosPlanilhaDetalhes: []
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        mxIsItau() {
            const nameGroupUpperCaseUnaccented = this.usuarioLogado?.nameGroup
                ?.toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            return nameGroupUpperCaseUnaccented === 'ITAU';
        },
        resetarValores() {
            this.carsConsultados = 0;
            this.cpfsCnpjsConsultados = 0;
            this.camadas = [];
            this.dadosPlanilhaDetalhes = [];
        },
        mxOnLoadFileItau(file) {
            if (this.validateFileFormat(file)) {
                this.resetarValores();
                const reader = new FileReader();
                this.canExport = false;
                reader.onload = async e => {
                    let hasValidInfo = false;
                    const arrayBuffer = e.target.result;
                    const data = new Uint8Array(arrayBuffer);
                    const workbook = XLSX.read(data, { type: 'array' });

                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];

                    const jsonData = XLSX.utils.sheet_to_json(sheet, {
                        header: 1, blankrows: false
                    });

                    const headerRow = jsonData[0];
                    const carCpfCnpjIndex = headerRow.findIndex(
                        column => column === 'CAR/CPF/CNPJ'
                    );

                    if (carCpfCnpjIndex === -1 || jsonData.length <= 1) {
                        this.showWarningMessage();
                        return;
                    }

                    const carCpfCnpjArray = jsonData.slice(1, 101).map(row => {
                        const value = row[carCpfCnpjIndex]
                            .toString()
                            .replace(/[^\w\s]/g, '');

                        if (
                            /^\d{11}$/.test(value) ||
                            /^\d{14}$/.test(value) ||
                            /^[A-Z]{2}\d{7}.+$/.test(value)
                        ) {
                            hasValidInfo = true;
                        }

                        return value;
                    });

                    if (!hasValidInfo) {
                        this.showWarningMessage();
                        return;
                    }

                    const { configuracaoProtocoloCamada } = (await ProtocolosService.buscarCamadasProtocolo(this.protocolo)).data;

                    const codigosAdicionados = new Set(
                        this.camadas.map(camada => camada.codigoCamada)
                    );
                    
                    for (const camada of configuracaoProtocoloCamada) {
                        if (!codigosAdicionados.has(camada.codigoCamada)) {
                            codigosAdicionados.add(camada.codigoCamada);
                            this.camadas.push({
                                ...camada,
                                carsConformes: 0,
                                carsInconformes: 0,
                                cpfsCnpjsConformes: 0,
                                cpfsCnpjsInconformes: 0
                            });
                        }
                    }

                    this.tableData = carCpfCnpjArray.map(item => ({
                        'CAR/Documento': item,
                        'Análise Socioambiental': this.$t(
                            'mensagens.diagnosticoSocioambiental.processando'
                        ),
                        'Área do CAR (ha)': '-'
                    }));

                    this.exportTable = carCpfCnpjArray.map(item => ({
                        'CAR/Documento': item,
                        camadas: [],
                        'Área do CAR (ha)': '-'
                    }));

                    for (let i = 0; i < carCpfCnpjArray.length; i++) {
                        this.canExport = false;
                        const item = carCpfCnpjArray[i];
                        
                        let hasAlto = false;
                        let hasMedio = false;
                        let hasBaixo = false;

                        let documentoPlanilha = null;
                        let documentoBusca = null;
                        let tipoBusca = null;

                        let buscaPorCar = false;
                        let buscaPorCpfCnpj = false;

                        if (/^[A-Z]{2}\d{7}.+$/.test(item)) {
                            documentoPlanilha = formatters.formatCar(item);
                            documentoBusca = documentoPlanilha;
                            tipoBusca = 'CODIGOCAR';
                            buscaPorCar = true;
                            this.carsConsultados++;

                        } else if (/^\d{11}$/.test(item) || /^\d{14}$/.test(item)) {
                            documentoPlanilha = formatters.numeralStringFormatToDocumento(item);
                            documentoBusca = item;
                            tipoBusca = 'CPF_CNPJ';
                            buscaPorCpfCnpj = true;
                            this.cpfsCnpjsConsultados++;

                        } else {
                            this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                        }

                        if (buscaPorCar || buscaPorCpfCnpj) {
                            try {
                                const response = await DiagnosticoSocioambientalService.consultarEmLote(
                                    tipoBusca,
                                    documentoBusca,
                                    true,
                                    this.protocolo
                                );

                                this.exportTable[i]['Situação'] = '-';
                                this.exportTable[i]['LocalidadeUf'] = '-';
                                this.exportTable[i]['Área do CAR (ha)'] = '-';
                                this.exportTable[i]['Bioma'] = '-';
                                this.exportTable[i]['Pastagem'] = '-';

                                let itemPlanilhaDetalhes = {
                                    carDocumento: documentoPlanilha,
                                    nivelAlerta: null,
                                    status: this.exportTable[i]['Situação'],
                                    areaHa: this.exportTable[i]['Área do CAR (ha)'],
                                    pastagem: this.exportTable[i]['Pastagem'],
                                    bioma: this.exportTable[i]['Bioma'],
                                    localidade: this.exportTable[i]['LocalidadeUf'],
                                    camada: '-',
                                    areaRestricaoHa: '-',
                                    data: '-',
                                    detalhes: '-'
                                };

                                if (response.data) {
                                    let informacoesGerais = response.data.informacoes_gerais;
                                    if (informacoesGerais) {
                                        this.camadaCar = informacoesGerais.camadaCar ?? null;
                                        this.camadaPastagem = informacoesGerais.camadaPastagem ?? null;
                                        this.exportTable[i]['Bioma'] = informacoesGerais.bioma ? informacoesGerais.bioma.trim() : '-';
                                        let areaPastagemHa = informacoesGerais.camadaPastagem?.areaPastagemHa ?? null;
                                        if (areaPastagemHa) {
                                            areaPastagemHa = formatters.formatNumber(areaPastagemHa, 2);
                                        }
                                        this.exportTable[i]['Pastagem'] = areaPastagemHa ?? '-';
                                    }

                                    let diagnosticos = [];
                                    if (buscaPorCar) {
                                        const dados = response.data.dataCAR[0];

                                        this.exportTable[i]['Situação'] = this.definirSituacao(dados.imovel.situacao);
                                        this.exportTable[i]['LocalidadeUf'] = dados.imovel.municipioUf;
                                        
                                        if (dados.imovel.areaHa != null) {
                                            const ha = formatters.formatNumber(dados.imovel.areaHa, 2);
                                            this.tableData[i]['Área do CAR (ha)'] = ha;
                                            this.exportTable[i]['Área do CAR (ha)'] = ha;
                                        }

                                        diagnosticos = dados.diagnosticos;
                                    }

                                    if (buscaPorCpfCnpj) {
                                        diagnosticos = response.data.dataCAR;
                                    }

                                    let conforme = true;
                                    if (diagnosticos && diagnosticos.length > 0) {
                                        diagnosticos.forEach(diagnostico => {
                                            switch (diagnostico.nivelAlerta) {
                                                case 'ALTO':
                                                    hasAlto = true;
                                                    break;

                                                case 'MEDIO':
                                                    hasMedio = true;
                                                    break;

                                                case 'BAIXO':
                                                    hasBaixo = true;
                                                    break;
                                            }

                                            this.exportTable[i].camadas.push(diagnostico);

                                            if (diagnostico.resultados && diagnostico.resultados.length > 0) {
                                                conforme = false;
                                                diagnostico.resultados.forEach(resultado => {
                                                    let areaRestricaoHa = '-';
                                                    if (resultado.areaHa) {
                                                        areaRestricaoHa = formatters.formatNumber(resultado.areaHa, 2);
                                                    }

                                                    const nivelAlerta = resultado.nivelAlerta ?? diagnostico.nivelAlerta;
                                                    
                                                    this.dadosPlanilhaDetalhes.push({
                                                        carDocumento: documentoPlanilha,
                                                        nivelAlerta: nivelAlerta,
                                                        status: this.exportTable[i]['Situação'],
                                                        areaHa: this.exportTable[i]['Área do CAR (ha)'],
                                                        pastagem: this.exportTable[i]['Pastagem'],
                                                        bioma: this.exportTable[i]['Bioma'],
                                                        localidade: this.exportTable[i]['LocalidadeUf'],
                                                        camada: diagnostico.camada.nome,
                                                        areaRestricaoHa: areaRestricaoHa,
                                                        data: this.definirDataCompleta(resultado, diagnostico.camada.fonte?.dataCadastro),
                                                        detalhes: this.definirDetalhes(resultado, nivelAlerta)
                                                    });
                                                });
                                            }
                                        });
                                    }

                                    if (conforme) {
                                        itemPlanilhaDetalhes.nivelAlerta = 'BAIXO';
                                        itemPlanilhaDetalhes.status = this.exportTable[i]['Situação'];
                                        itemPlanilhaDetalhes.areaHa = this.exportTable[i]['Área do CAR (ha)'];
                                        itemPlanilhaDetalhes.pastagem = this.exportTable[i]['Pastagem'];
                                        itemPlanilhaDetalhes.bioma = this.exportTable[i]['Bioma'];
                                        itemPlanilhaDetalhes.localidade = this.exportTable[i]['LocalidadeUf'];
                                        this.dadosPlanilhaDetalhes.push(itemPlanilhaDetalhes);
                                    }

                                } else {
                                    this.dadosPlanilhaDetalhes.push(itemPlanilhaDetalhes);
                                }

                                const analysisResult = this.determineAnalysisResult(hasAlto, hasMedio, hasBaixo);
                                this.exportTable[i]['Resultado'] = analysisResult;
                                this.tableData[i]['Análise Socioambiental'] = analysisResult;

                            } catch (error) {
                                this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                            }
                        }
                    }

                    this.canExport = true;
                };

                reader.readAsArrayBuffer(file.raw);
            }
        },
        mxExportToExcelItau() {
            const filename = 'diagnostico-socioambiental-lote.xlsx';
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('INFORMACOES');

            worksheet.addRows([
                ['Data da consulta:', new Date().toLocaleDateString('pt-BR')],
                ['CARs consultados:', this.carsConsultados],
                ['CPFs/CNPJs consultados:', this.cpfsCnpjsConsultados],
                [],
                [
                    'Camada',
                    'CARs',
                    'CPFs/CNPJs',
                    'Fonte',
                    'Data atualização',
                    'URL'
                ]
            ]);

            for (let i = 1; i <= 3; i++) {
                worksheet.getRow(i).getCell(1).font = { bold: true };
            }

            worksheet.getRow(5).eachCell(cell => {
                cell.font = { bold: true };
            });

            const rowsCamadas = [];
            const codigosAdicionados = new Set();

            this.camadas.forEach(camada => {
                if (!codigosAdicionados.has(camada.codigoCamada)) {
                    codigosAdicionados.add(camada.codigoCamada);
                    rowsCamadas.push(
                        worksheet.addRow([
                            camada.nomeCamada,
                            '',
                            '',
                            camada.nomeFonteCamada,
                            camada.dataCadastroFonteCamada,
                            camada.urlFonteCamada
                        ])
                    );
                }
            });

            if (this.carsConsultados > 0) {
                if (this.camadaPastagem) {
                    let dataAtualizacao = this.camadaPastagem.fonte?.dataAtualizacao;
                    if (dataAtualizacao) {
                        dataAtualizacao = formatters.localDateToString(dataAtualizacao);
                    }

                    worksheet.addRow([
                        'Pastagem',
                        '-',
                        '-',
                        this.camadaPastagem.fonte?.nome ?? '-',
                        dataAtualizacao ?? '-',
                        this.camadaPastagem.fonte?.url ?? '-'
                    ]);
                }

                if (this.camadaCar) {
                    worksheet.addRow([
                        'CAR',
                        '-',
                        '-',
                        this.camadaCar.fontes?.[0]?.nome ?? '-',
                        this.camadaCar.dataAtualizacaoDados ?? '-',
                        this.camadaCar.fontes?.[0]?.url ?? '-'
                    ]);
                }
            }

            worksheet.addRow();

            const nomesCamadas = this.camadas.map(camada => camada.nomeCamada);

            const indexCamadaTerrasIndigenas = nomesCamadas.indexOf(constTerrasIndigenas);
            if (indexCamadaTerrasIndigenas !== -1) {
                nomesCamadas.splice(indexCamadaTerrasIndigenas + 1, 0, constProcessoFaseTerrasIndigenas);
            }

            const cabecalhoAnalise = worksheet.addRow([
                'Item Analisado',
                'Resultado',
                'Status',
                'Área do CAR (ha)',
                'Pastagem (ha)',
                'Localidade',
                'Bioma',
                ...nomesCamadas
            ]);

            cabecalhoAnalise.eachCell(cell => {
                cell.font = { bold: true };
            });

            for (const row of this.exportTable) {
                const formattedData = this.formatTableData(
                    row,
                    'CAR/Documento',
                    row['CAR/Documento']
                );

                const rowData = [
                    formattedData,
                    row['Resultado'],
                    row['Situação'],
                    row['Área do CAR (ha)'],
                    row['Pastagem'],
                    row['LocalidadeUf'],
                    row['Bioma'],
                    ...this.mxExtractCamadaValuesItau(row, nomesCamadas)
                ];

                const newRow = worksheet.addRow(rowData);

                newRow.getCell(1).font = { bold: false };
            }

            rowsCamadas.forEach(row => {
                const celulaCamada = row.getCell(1);
                const camada = this.camadas.find(
                    camada => camada.nomeCamada === celulaCamada.value
                );

                let valorColunaCars;
                let valorColunaCpfsCnpjs;

                if (camada.carsConformes + camada.carsInconformes) {
                    if (camada.carsInconformes) {
                        valorColunaCars = this.$t('mensagens.diagnosticoSocioambiental.inconforme');
                    } else {
                        valorColunaCars = this.$t('mensagens.diagnosticoSocioambiental.conforme');
                    }
                } else {
                    valorColunaCars = '-';
                }

                if (camada.cpfsCnpjsConformes + camada.cpfsCnpjsInconformes) {
                    if (camada.cpfsCnpjsInconformes) {
                        valorColunaCpfsCnpjs = this.$t('mensagens.diagnosticoSocioambiental.inconforme');
                    } else {
                        valorColunaCpfsCnpjs = this.$t('mensagens.diagnosticoSocioambiental.conforme');
                    }
                } else {
                    valorColunaCpfsCnpjs = '-';
                }

                row.getCell(2).value = valorColunaCars;
                row.getCell(3).value = valorColunaCpfsCnpjs;
            });

            this.calcularTamanhoCelula(worksheet, 1, 7);

            const colunaUrlLocalidade = worksheet.getColumn(6);
            colunaUrlLocalidade.width = 30;

            for (let i = 8; i <= worksheet.columns.length; i++) {
                const coluna = worksheet.getColumn(i);
                coluna.eachCell(cell => {
                    if (cell._row._number > 5 && cell.style?.font) {
                        coluna.width = cell.value.length + 2;
                    }
                });
            }
            
            this.criarPlanilhaDetalhes(workbook);

            workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(link.href);
            });
        },
        criarPlanilhaDetalhes(workbook) {
            const worksheet = workbook.addWorksheet('DETALHES');

            worksheet.addRows([
                ['ITEM ANALISADO', 'RESULTADO', 'STATUS', 'ÁREA DO CAR (HA)', 'PASTAGEM (HA)', 'BIOMA', 'CIDADE', 'ALERTA', 'ÁREA DE RESTRIÇÃO (HA)', 'DATA COMPLETA', 'DETALHES']
            ]);

            worksheet.getRow(1).eachCell(cell => {
                cell.font = { bold: true };
            });

            this.dadosPlanilhaDetalhes.forEach(detalhe => {
                worksheet.addRows([
                    [detalhe.carDocumento, this.determineMaxAlert(detalhe.nivelAlerta), detalhe.status, detalhe.areaHa, detalhe.pastagem, detalhe.bioma, detalhe.localidade, detalhe.camada, detalhe.areaRestricaoHa, detalhe.data, detalhe.detalhes]
                ]);
            });

            this.calcularTamanhoCelula(worksheet, 1, worksheet.columns.length - 1);
        },
        definirSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.ativo'
                    );
                case 'PE':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.pendente'
                    );
                case 'SU':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.suspenso'
                    );
                case 'CA':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.cancelado'
                    );
                default:
                    return '-';
            }
        },
        definirDataCompleta(resultado, dataAtualizacaoCamada) {
            if (resultado.image_date) {
                return resultado.image_date;
            }

            if (resultado.data_tad) {
                return resultado.data_tad;
            }

            if (resultado.datadetec) {
                return dateUtils.formatStringDateUsingLocale(resultado.datadetec, 'pt-br');
            }

            if (dataAtualizacaoCamada) {
                return dataAtualizacaoCamada;
            }

            return '-';
        },
        mxGetAnaliseCamadaItau(camada) {
            if (camada?.resultados && camada.resultados.length > 0) {
                const resultados = [];

                for (const resultado of camada.resultados) {
                    resultados.push(this.definirDetalhes(resultado, camada.nivelAlerta));
                }

                return resultados.join('\n\n');
            }
        },
        definirDetalhes(resultado, nivelAlerta) {
            const campos = [
                ['Nome/Razão Social', 'nome_pessoa'],
                ['Proprietário', 'autuado'],
                ['Documento', 'cpf_cnpj'],
                ['Área total(ha)', 'areaTotalFeatureHa'],
                ['Percentual de sobreposição', 'percentualSobreposicaoGeometria'],
                ['Área restrição(ha)', 'areaHa'],
                ['Categoria', 'categoria'],
                ['Tipo', 'tipo'],
                ['Número do Auto de Infração', 'numero_auto_infracao'],
                ['Número do Auto de Infração', 'num_auto_infracao'],
                ['Número do Auto de Infração', 'numero_aut'],
                ['Número do Auto de Infração', 'numero_ai'],
                ['Descrição Auto de Infração', 'descricao_auto_infracao'],
                ['Descrição da Infração', 'descricao_infracao'],
                ['Descrição da Infração', 'desc_infra'],
                ['Número do TAD', 'numero_tad'],
                ['Número do TAD', 'num_tad'],
                ['Data do TAD', 'data_tad'],
                ['Descrição do TAD', 'descricao_tad'],
                ['Descrição do TAD', 'descricao_da_apreensao_embargo'],
                ['Descrição do TAD', 'des_tad'],
                ['Área', 'area_total'],
                ['Área', 'area'],
                ['Unidade de conservação', 'nome_uc'],
                ['CNUC', 'cnuc'],
                ['CNUC', 'codigo_cnuc'],
                ['Série', 'serie'],
                ['UF', 'uf'],
                ['UF', 'sigla_estado'],
                ['Estado', 'estado'],
                ['Municipio', 'municipio'],
                ['Data detecção', 'data_deteccao'],
                ['Data detecção', 'datadetec'],
                ['Ano detecção', 'anodetec'],
                ['Código do alerta', 'codealerta'],
                ['Fonte', 'fonte'],
                ['Nome', 'nome'],
                ['Nome', 'identifica'],
                ['Nome', 'nome_proje'],
                ['Nome', 'nm_comunid'],
                ['Esfera', 'esfera'],
                ['Natureza', 'ds_naturez'],
                ['Natureza', 'natureza'],
                ['IPHAN', 'co_iphan'],
                ['Classificação', 'ds_classif'],
                ['Logradouro', 'no_logrado'],
                ['Logradouro', 'nu_logrado'],
                ['Data de detecção', 'view_date'],
                ['Data de detecção', 'dt_cadastr'],
                ['Data de detecção', 'acq_date'],
                ['Data da imagem', 'image_date'],
                ['Código', 'codigo_ti'],
                ['Código', 'codigo'],
                ['Código', 'codigo_do'],
                ['Fase', 'fase'],
                ['Modalidade', 'modalidade'],
                ['Etnia', 'etnia'],
                ['Etnia', 'pueblo_etn'],
                ['Unidade', 'unidade_administrativa'],
                ['Unidade', 'unidade'],
                ['Plano de Manejo', 'possui_plano_manejo'],
                ['Data administrativa', 'data_administrativa_procedencia'],
                ['Estabelecimento', 'estabelecimento'],
                ['Ano ação fiscal', 'ano_acao_fiscal'],
                ['Ano', 'ano'],
                ['Data inclusão trabalhadores', 'data_inclusao_cadastro_trabalhadores'],
                ['Empregador', 'empregador'],
                ['Trabalhadores', 'trabalhadores_envolvidos'],
                ['CNAE', 'cnae']
            ];

            const resultadosCamada = [];

            for (const campo of campos) {
                try {
                    if (resultado[campo[1]]) {
                        this.mxAdicionarCampoResultadosItau(
                            resultadosCamada,
                            campo[0],
                            resultado[campo[1]]
                        );
                        
                    } else if (resultado.properties[campo[1]]) {
                        this.mxAdicionarCampoResultadosItau(
                            resultadosCamada,
                            campo[0],
                            resultado.properties[campo[1]]
                        );
                        
                    }
                } catch (e) {
                    continue;
                }
            }

            resultadosCamada.push(`Criticidade da Restrição: ${nivelAlerta}`);

            return resultadosCamada.join(', ');
        },
        mxAdicionarCampoResultadosItau(resultados, nome, valor) {
            let valorFormatado = valor.replace(/(\r\n|\n|\r)/gm, '');

            if (nome === 'Documento') {
                valorFormatado = formatters.numeralStringFormatToDocumento(valorFormatado);

            } else if (nome.toLowerCase().includes('área') || nome.toLowerCase().includes('percentual')) {
                const valorNumerico = Number(valorFormatado);
                if (Number.isFinite(valorNumerico)) {
                    valorFormatado = formatters.formatNumber(valorNumerico, 2);

                    if (nome.toLowerCase().includes('percentual')) {
                        valorFormatado += '%';
                    }
                }
            }

            resultados.push(`${nome}: ${valorFormatado}`);
        },
        mxExtractCamadaValuesItau(row, headers) {
            const camadasResultado = row.camadas;
            const tipoDiagnostico = row['CAR/Documento'].length > 14 ? 'CAR' : 'CPF_CNPJ';

            return headers.map(header => {
                const ehProcessoFaseTerraIndigena = header.toLowerCase() === constProcessoFaseTerrasIndigenas.toLowerCase() && tipoDiagnostico === 'CAR';

                const nomeCamada = ehProcessoFaseTerraIndigena ? constTerrasIndigenas : header;

                const camada = camadasResultado.find(
                    camada => camada.camada.nome === nomeCamada
                );

                if (camada) {
                    const camadaLista = this.camadas.find(c => c.codigoCamada === camada.camada.codigo);

                    const alertaBaixo = camada.nivelAlerta === 'BAIXO';
                    const diagnosticoCpfCnpj = tipoDiagnostico === 'CPF_CNPJ';

                    if (alertaBaixo) {
                        if (diagnosticoCpfCnpj) {
                            camadaLista.cpfsCnpjsConformes++;
                        } else {
                            camadaLista.carsConformes++;
                        }

                    } else {
                        if (diagnosticoCpfCnpj) {
                            camadaLista.cpfsCnpjsInconformes++;
                        } else {
                            camadaLista.carsInconformes++;
                        }
                    }

                    if (ehProcessoFaseTerraIndigena) {
                        const resultado = this.mxGetAnaliseCamadaItau(camada);
                        return this.mxIdentificarProcessoFaseTerrasIndigenas(resultado);
                    }

                    return alertaBaixo ? this.$t('mensagens.diagnosticoSocioambiental.conforme') : this.mxGetAnaliseCamadaItau(camada);
                }

                return '-';
            });
        },
        mxIdentificarProcessoFaseTerrasIndigenas(resultadoTerraIndigena) {
            if (resultadoTerraIndigena) {
                const resultado = resultadoTerraIndigena.toLowerCase();

                if (resultado.includes('Fase: Regularizada'.toLowerCase())) {
                    return 'Homologada';
                }

                if (resultado.includes('Fase: Homologada'.toLowerCase())) {
                    return 'Homologada';
                }

                if (resultado.includes('Fase: Declarada'.toLowerCase())) {
                    return 'Não homologada';
                }

                if (resultado.includes('Fase: Delimitada'.toLowerCase())) {
                    return 'Não homologada';
                }

                if (resultado.includes('Fase: Encaminhada RI'.toLowerCase())) {
                    return 'Não homologada';
                }

                if (resultado.includes('Fase: Em Estudo'.toLowerCase())) {
                    return 'Não homologada';
                }
            }

            return '-';
        },
        calcularTamanhoCelula(worksheet, colunaInicial, colunaFinal) {
            for (let i = colunaInicial; i <= colunaFinal; i++) {
                const coluna = worksheet.getColumn(i);

                const tamanhos = coluna.values.map(value =>
                    value ? value.toString().length : 0
                );

                const maiorTamanho = Math.max(
                    ...tamanhos.filter(v => typeof v === 'number')
                );

                let acrescimo = 4;
                if (maiorTamanho > 50) {
                    acrescimo = -5;
                }

                coluna.width = maiorTamanho + acrescimo;
            }
        }
    }
};
